import {transformImage} from "../../../utils/StoryblokService";
import {IStoryblokImage} from "../../../types/IStoryblokImage";
import React, {useState} from "react";
import BackgroundPattern from "../../internal/BackgroundPattern";
import Lightbox from "../../gallery/Lightbox";
import {IProjectItem} from "../../../types/IProjectItem";
import Image from "next/image";

interface IProps {
    project: IProjectItem
}

const GalleryItem = ({screenshot}: { screenshot: IStoryblokImage }) => {
    const [isShowing, setIsShowing] = useState(false);

    return <div className={'col-span-1 bg-white rounded-md p-2'}>
        <Lightbox isShowing={isShowing}
                  onClose={() => setIsShowing(false)}
        >
            <img
                src={transformImage(screenshot.filename, "/fit-in/1920x1080/filters:fill(transparent):format(png)")}
                className={"w-full"}
                alt={screenshot.title}
                onClick={() => setIsShowing(true)}
            />

        </Lightbox>


        <div className={'relative aspect-[3/2] w-full'}>
            <Image
                src={transformImage(screenshot.filename, "0x400")}
                className={"w-full object-contain aspect-[3/2] cursor-pointer"}
                alt={screenshot.title}
                title={screenshot.title}
                fill={true}
                onClick={() => setIsShowing(true)}
            />
        </div>

    </div>
}

const ProjectGallery: React.FC<IProps> = ({project}) => {

    if (!project.content?.images || project.content?.images?.length < 2) return null;

    const galleryItems = project.content.images.slice(1).map((screenshot, index) => {
        return <GalleryItem screenshot={screenshot} key={index}/>
    });

    return <div className={'w-full grid grid-cols-3 gap-4'}>
        {galleryItems}
    </div>
}

export default ProjectGallery;